/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ConfigurationProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// temporary configuration by scope for testing
		// TODO: Remove this when the Configuration API is available
		this.tmpConfigurationByScope = [
			{
				'IDCustomer': 117,
				'ConfigurationID': 'HDOT',
				'State': 'Hawaii',
				'StateAbbreviation': 'HI',
				'Agency': 'HDOT',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 13,
					'LeafletInitialCenter': [ 21.315603, -157.858093 ],
				},
			},
			{
				'IDCustomer': 63,
				'ConfigurationID': 'ALDOT',
				'State': 'Alabama',
				'StateAbbreviation': 'AL',
				'Agency': 'ALDOT',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 10,
					'LeafletInitialCenter': [ 32.4074958, -86.2651064 ],
				},
			},
			{
				'IDCustomer': 16,
				'ConfigurationID': 'Transystems',
				'State': [ 'South Carolina', 'Pennsylvania' ],
				'StateAbbreviation': [ 'SC', 'PA' ],
				'Agency': 'Transystems',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 10,
					'LeafletInitialCenter': [ 32.89979011186591, -79.97861499691103 ],
				},
			},
			{
				'IDCustomer': 1,
				'ConfigurationID': 'Headlight',
				'State': 'Headlight',
				'StateAbbreviation': null,
				'Agency': 'Headlight',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 5,
					'LeafletInitialCenter': [ 47.6142773, -122.3586997 ],
				},
			},
			{
				'IDCustomer': 188,
				'ConfigurationID': 'MoffattNichol',
				'State': [ 'Alaska', 'Louisiana' ],
				'StateAbbreviation': [ 'AK', 'LA' ],
				'Agency': 'Moffatt & Nichol',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 5,
					'LeafletInitialCenter': [ 61.1070663, -150.0733888 ],
				},
			},
			{
				'IDCustomer': 178,
				'ConfigurationID': 'BridgeEngineering',
				'State': 'Headlight',
				'StateAbbreviation': null,
				'Agency': 'Bridge Engineering',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 5,
					'LeafletInitialCenter': [ 32.8001818028968, -96.67293809033943 ],
				},
			},
			{
				'IDCustomer': 184,
				'ConfigurationID': 'IndustrySolutions',
				'State': 'Pennsylvania',
				'StateAbbreviation': 'PA',
				'Agency': 'Industry Solutions',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 10,
					'LeafletInitialCenter': [ 40.437801138712196, -79.99294555569139 ],
				},
			},
		];
	}

	getConfigurationByScope(pScope, pCallback)
	{
		if (!pScope)
		{
			this.pict.log.error('No Configuration Scope provided.');
			return new Error('No Configuration Scope provided.');
		}
		const tmpScopeConfig = this.tmpConfigurationByScope.filter((pConfig) => pConfig.IDCustomer === pScope);

		// find the temporary configuration by scope for testing where the pScope is the IDCustomer (for now)
		if (tmpScopeConfig && tmpScopeConfig.length > 0)
		{
			// return the first configuration found
			const tmpResult = tmpScopeConfig[0];
			this.pict.log.info(`Configuration found for ${pScope}`, tmpResult);
			if (pCallback)
			{
				pCallback(tmpResult);
			}
			return tmpResult;
		}
		else
		{
			this.pict.log.error(`Configuration not found for passed value: ${pScope}`);
			if (pCallback)
			{
				pCallback({});
			}
			return {};
		}
		// this.pict.HeadlightRestClient.getJSON(`Configuration/Scope/${pScope}`, (pError, pBody) =>
		// {
		// 	if (pError)
		// 	{
		// 		this.pict.log.error(`Error getting Configuration: ${pError}`, pError);
		// 		return reject(pError);
		// 	}
		// 	resolve(pBody);
		// });
	}
}

module.exports = ConfigurationProvider;
module.exports.default_configuration = {};
